import { ProductType } from '@inter-ikea-storageone/range';
import { ProductListConfig } from 'rangeConfig/@types';
import autoFillLegs from 'rangeConfig/besta/behaviors/autoFillLegs';

const legsProductListConfig: ProductListConfig = {
  cardsTitle: 'name',
  cardsSubtitle: 'typeName, designText communicatedSizeText',
  behaviors: {
    productClicked: [autoFillLegs],
    productDropped: [autoFillLegs]
  },
  cluster: [],
  sortOrder: [{ path: 'name' }],
  categories: [
    {
      id: 'legs',
      categoryTitle: '',
      products: [
        { path: 'type', value: ProductType.BESTA_DEFAULT_LEG },
        { path: 'type', value: ProductType.BESTA_LEG }
      ]
    }
  ]
};

export default legsProductListConfig;
